import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/routes/ProtectedRoute';
import LoginPage from '@/pages/LoginPage';
import CadastroPage from '@/pages/CadastroPage';
import ConfirmarEmailPage from '@/pages/ConfirmarEmailPage';
import EsqueciSenhaPage from '@/pages/EsqueciSenhaPage';
import PerfilPage from '@/pages/PerfilPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cadastro" element={<CadastroPage />} />
          <Route path="/confirmar-email" element={<ConfirmarEmailPage />} />
          <Route path="/esqueci-minha-senha" element={<EsqueciSenhaPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Navigate to="/perfil" replace />} />
            <Route path="/perfil" element={<PerfilPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/perfil" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
